(() => {
  if (window.fwVideoLazyReady) return;
  window.fwVideoLazyReady = true;
  const start = video => {
    if (video.dataset.fwVideoLoaded) return;
    video.dataset.fwVideoLoaded = 'true';
    video.autoplay = true;
    video.load();
    video.play()?.catch(() => {});
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        start(entry.target);
      });
    }, { rootMargin: '300px 0px' })
    : null;
  const watch = root => {
    root.querySelectorAll('video.fw-lazy-video').forEach(video => {
      if (video.dataset.fwVideoWatched) return;
      video.dataset.fwVideoWatched = 'true';
      if (observer) observer.observe(video);
      else start(video);
    });
  };
  watch(document);
  document.addEventListener('shopify:section:load', event => watch(event.target));
})();
